export function encodePassphrase(passphrase: string) {
  return encodeURIComponent(passphrase);
}

export function decodePassphrase(base64String: string) {
  return decodeURIComponent(base64String);
}

export function generateRoomId(): string {
  return `${randomString(4)}-${randomString(4)}`;
}

export function randomString(length: number): string {
  let result = '';
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function isLowPowerDevice() {
  return navigator.hardwareConcurrency < 6;
}

export function isMeetStaging() {
  return new URL(location.origin).host === 'meet.staging.livekit.io';
}

/**
 * 从 LiveKit participant 中提取纯用户名
 * identity 格式为 "用户名__随机后缀"，此函数提取纯用户名部分
 * 解决中文用户名因 cookie 过期导致的录像列表匹配问题
 */
export function extractUsername(participant: { name?: string; identity: string }): string {
  // 优先使用 name（如果存在且非空）
  if (participant.name && participant.name.trim()) {
    return participant.name;
  }
  // 从 identity 中提取用户名（去掉 __xxx 后缀）
  const identity = participant.identity;
  const separatorIndex = identity.lastIndexOf('__');
  if (separatorIndex > 0) {
    return identity.substring(0, separatorIndex);
  }
  return identity;
}
